module.exports = __webpack_public_path__ + "img/boci_car_discounts_banner.8bc17aac.png";